/**
 * GENERATED FILE — do not hand-edit (#309).
 *
 * `SCHEMA_HASH` is the committed, precomputed hash of every boundary
 * schema's JSON-Schema shape (see `../schemaHash.ts` for what/how). Keeping
 * it as a checked-in constant (rather than calling `computeSchemaHash()` at
 * app startup) means `PROTOCOL_VERSION` composition (`limits.ts`) is a cheap
 * string template, and a schema change shows up as an ordinary reviewable
 * diff to THIS file instead of silently changing behavior on every boot.
 *
 * Regenerate after changing any boundary schema (`ClientMessage`/
 * `ServerMessage`/`Replay`/`Champion`/`Ability`/`AuraDef`/`Map`/`Tuning`):
 *
 *   pnpm --filter @pit/protocol regen-schema-hash
 *
 * `pnpm --filter @pit/protocol regen-schema-hash:check` is the CI-safe
 * dry-run (exits non-zero on drift, writes nothing). `test/schemaHash.
 * test.ts` runs the equivalent check as an ordinary vitest case, so a stale
 * value here fails `pnpm test` (and therefore `pnpm check`) loudly — the
 * actual enforcement gate, same convention as `@pit/content`'s
 * `GOLDEN_CONTENT_HASH` (#260/#261).
 */

export const SCHEMA_HASH = "sha256:4f31b92f77837878";
